<template>
  <v-container fluid class="relative-container">

    <Title :title="`Lista de ${catalogType}`"
           :description="'Registro de ' + (totalItems ? ' ' + totalItems + ' ' : ' ') + `${catalogType} en el sistema`"
    />

    <!-- Search bar -->
    <v-row justify="space-between">
      <v-col cols="12" md="7">
        <v-text-field
            v-model="searchQuery"
            prepend-inner-icon="mdi-magnify"
            label="Buscar"
            outlined
            dense
            clearable
            hide-details
            class="white"
        >
        </v-text-field>
      </v-col>

      <!-- Create button -->
      <v-col cols="12" md="4" xl="3" class="d-flex align-center">
        <v-btn
            block
            color="primary"
            height="40"
            @click="openDialogCreateItem"
        >
          <v-icon left>mdi-plus-box</v-icon>
          Registrar {{ catalogType.replace(/s$/, "") }}
        </v-btn>
      </v-col>

      <DialogCreateItem :item-type="catalogType" ref="dialogCreateItem" @item-created="loadCatalog"/>
    </v-row>

    <!-- Catalogs -->
    <v-row v-if="catalogList.length > 0">
      <v-col v-for="item in catalogList" :key="item.name" cols="12" sm="6" md="4">
        <v-card
            outlined
            elevation="2"
            class="fill-height selectable-card"
            @click="selectItem(item)"
        >
          <v-card-title>
            <v-row>
              <v-col class="px-2 text-break" cols="8">
                <span>{{ item.name }}</span>
              </v-col>
              <v-col class="px-2 text-end" cols="4">
                <StatusChip
                    v-if="isAdmin"
                    :status="item.status"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p>{{ item.description || "Sin descripción" }}</p>
          </v-card-text>
        </v-card>
      </v-col>

      <DialogEditItem :originalItem="selectedItem" :item-type="catalogType" ref="dialogEditItem"
                      @item-created="loadCatalog"/>

      <!-- Pagination -->
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination
            v-model="page"
            :length="totalPages"
            @input="loadCatalog"
        ></v-pagination>
      </v-col>
    </v-row>

    <v-row v-else-if="!isLoading && catalogList.length === 0">
      <v-col cols="12">
        <v-alert
            color="amber"
            icon="mdi-information"
        >
          No se encontraron registros de {{ catalogType }}.
        </v-alert>
      </v-col>
    </v-row>

    <OverlayLoading v-else-if="isLoading"/>

  </v-container>
</template>

<script lang="ts">
import Vue from "vue";

import throwErrorMessage from "@/utils/ErrorMessage";

import CatalogService from "@/services/catalogs/CatalogService";
import {RequestCatalogPage} from "@/services/catalogs/entities/RequestCatalogPage";

import Title from "@/components/Title.vue";
import DialogCreateItem from "@/views/catalogs/components/DialogCreateItem.vue";
import DialogEditItem from "@/views/catalogs/components/DialogEditItem.vue";
import OverlayLoading from "@/components/OverlayLoading.vue";
import StatusChip from "@/components/StatusChip.vue";

export default Vue.extend({
      name: "CatalogList",
      components: {
        Title,
        DialogCreateItem,
        DialogEditItem,
        OverlayLoading,
        StatusChip,
      },
      data() {
        return {
          // Catalogs
          catalogType: "" as string,
          catalogList: [] as any[],
          catalogTypes: ["bebidas", "medicamentos", "padecimientos", "dietas"],
          selectedItem: {} as any,

          // Pagination
          page: 1 as number,
          size: 9 as number,
          searchQuery: "" as string,
          totalPages: 0 as number,
          totalItems: 0 as number,

          // Loading
          isLoading: false as boolean,
        };
      },
      watch: {
        "$route.params.catalogType": function () {
          this.page = 1;
          this.totalItems = 0;
          this.totalPages = 0;
          this.loadCatalog();
        },
        searchQuery: {
          handler: function () {
            this.page = 1;
            this.loadCatalog();
          },
          immediate: false,
        },
      },
      computed: {
        sessionUser() {
          return this.$store.getters["auth/getUser"]
        },
        isAdmin(): boolean {
          return this.sessionUser.role !== 'DIETICIAN';
        },
      },
      methods: {
        async loadCatalog() {
          this.catalogType = "";
          this.catalogList = [];
          this.isLoading = true;

          try {

            const catalogTypeParam = this.$route.params.catalogType;
            if (!this.catalogTypes.includes(catalogTypeParam)) {
              throwErrorMessage("No se encontró el catálogo solicitado.");
              this.$router.go(-1);
              return;
            }
            this.catalogType = catalogTypeParam;
            const body: RequestCatalogPage = {
              page: this.page - 1,
              size: this.size,
              searchQuery: this.searchQuery,
            };
            const response = await CatalogService.getCatalogPage(body, this.catalogType);
            // filter inactive items for non-admin users
            if (!this.isAdmin) {
              response.content = response.content.filter((item: any) => item.status);
            }
            this.catalogList = response.content;
            this.totalPages = response.totalPages;
            this.totalItems = response.totalElements;

          } finally {
            this.isLoading = false;
          }
        },
        selectItem(item: any) {
          if (!this.isAdmin) return;
          this.selectedItem = item;
          (this.$refs.dialogEditItem as any).dialog = true;
        },
        openDialogCreateItem() {
          (this.$refs.dialogCreateItem as any).dialog = true;
        },
      },

      async created() {
        await this.loadCatalog();
      },
    }
);
</script>